import { render, staticRenderFns } from "./GroupCourse.vue?vue&type=template&id=566e9b16"
import script from "./GroupCourse.vue?vue&type=script&lang=js"
export * from "./GroupCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports